import {Injectable} from '@angular/core';
import {FormbirdInjectorService, RouterService} from 'formbird-services';

@Injectable({
  providedIn: 'root'
})
export class SclUtilUrlService {
  private documentModalService: any;

  constructor(private formbirdInjectorService: FormbirdInjectorService, private routerService: RouterService) {
    this.documentModalService = this.formbirdInjectorService.get('DocumentModalService');
  }

  openLink(link: string, mode?: string, componentScope?: any) {
    const openMode = mode ? mode : 'currentWindow';
    switch (openMode) {
      case 'currentWindow' :
        this.routerService.navigateByUrl(link)
        break;

      case 'newWindow':
        window.open(link, '_blank');
        break;

      case 'popup' :
        window.open(link, undefined, 'height=300,width=600');
        break;

      case 'overlay':
        const documentId = this.getDocIdFromLink(link);
        componentScope.selectedDocumentId = documentId;
        this.documentModalService.openDocumentInModal(documentId, componentScope);
        break;

      case 'noDisplay' :
        break;
      default :
        this.routerService.navigateByUrl(link)
        break;
    }
  }

  getDocIdFromLink(link) {
    const lstIdx = link.lastIndexOf('/');
    if (!link || lstIdx === -1) {
      return null;
    } else {
      return link.substr(lstIdx + 1, link.length);
    }
  }
}

